import styled from "styled-components";

import { FlexRow, RadioButton } from "@similarweb/ui-components";

export const StyledRadioButton = styled(RadioButton)`
    padding: 0;
`;

export const Container = styled(FlexRow)`
    gap: 16px;
`;
export const StyledRadioContainer = styled.div`
    align-items: center;
    display: flex;
`;
